import AppBarContainer from '@components/micro-container/app-bar'

// 银行直播管理微前端
const routes = [
  {
    path: '/micro-admin-bank-live',
    component: AppBarContainer,
    module: 'MICRO_CONTAINER',
  },
]

export default routes
